import {ModalEquipmentWrite} from "./ModalEquipmentWrite";


import {Button} from "../../shadCn/components/ui/button"

import {Dialog, DialogClose, DialogFooter, DialogTitle, DialogTrigger,} from "../../shadCn/components/ui/dialog"
import {selectEquipment} from "../../api/equipment/equipmentService";
import React, {useEffect, useRef, useState} from "react";
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../commonmethod/CommonMethod";
import SearchComponent from "../search/SearchComponent";
import TableEquipment from "../table/TableEquipment";
import UtilsBox from "../Utils/UtilsBox";
import SearchComponentRadioGroup from "../input/SearchComponentRadioGroup";
import {useSelector} from "react-redux";
import {EQUIPMENT_ACCESS_LIST_HEADER} from "../table/header/Headers";
import {CameraIcon} from "@heroicons/react/24/outline";
import EquipmentIcon from "../../resources/icon/equipment_icon.png"
import UploadHere from "../../resources/icon/upload.png";
import ExcelIcon from "../../resources/icon/excel-export.png";
import Printer from "../../resources/icon/pirnter-bw.png";
import {downloadExcelByEntity} from "../commonmethod/excelMethod";

const ioCheck = [
    {value: '', text: "전체"},
    {value: true, text: "반입"},
    {value: false, text: "반출"}
];

const deleteCheck = [
    {value: '', text: "전체"},
    {value: true, text: "삭제"},
    {value: false, text: "미삭제"}
];

const infectionCheck = [
    {value: '', text: "전체"},
    {value: true, text: "확인"},
    {value: false, text: "확인불가"}
];

export function ModalEquipmentAccess({isIconTrigger = false}) {
    const user = useSelector((state) => state.auth.user);
    const [modalOpen, setModalOpen] = useState(false);
    const isInitialRender = useRef(true);
    const currentDate = new Date();
    const [date, setDate] = useState({
        from: addYears(currentDate, -1),
        to: addYears(currentDate, 0),
    });
    const [search, setSearch] = useState({
        searchTxt: "",
        ioCheck: "",
        deleteCheck: "",
        infectionCheck: "",
        startDate: toKSTISOString(date.from),
        endDate: toKSTISOStringEnd(date.to),
    });
    const [pageable, setPageable] = useState({
        sort: "createdAt",
        desc: true,
        size: 10,
        totalElements: 0,
        totalPages: 0,
        page: 0
    });
    const [data, setData] = useState();
    const [checked, setChecked] = useState([]);



    useEffect(() => {
        //현재 컴포넌트가 마운트 될 때 1번, 로딩되며 1번 하여 페이지에 오는 것 만으로 api 요청 총 2번 하게되는데 그걸 방지해서 api 요청을 한 번만 하도록 하기 위한 로직
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        getList();

    }, [pageable.page]);

    // useEffect(() => {
    //     getList();
    //     dispatch(refresh(false));
    // }, [status]);

    const option = {
        url: "/equipment",
        width: 100
    }

    async function getList() {
        try {
            const response = await selectEquipment(search, pageable);

            if (response.status === 200) {
                response.data.option = option;
                setData({...response.data});
                setPageable((prevState) => ({
                    ...prevState,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                }));
            }
        } catch (error) {
        } finally {
        }
    }

    // 모달 열기 및 데이터 가져오기 함수 분리
    const handleOpenModalAndFetchData = () => {
        // 1. 모달을 열기
        setModalOpen(true);
        // 2. 데이터 가져오기
        getList();
    };


    function radioCheck(selected, type){
        setSearch((prev) => {
            return {
                ...prev,
                [type] : selected
            }
        })
    }

    function handlePrint(printAreaId) {
        const printArea = document.getElementById(printAreaId);
        const originalContent = document.body.innerHTML;

        const printContent = `
        <div>
        
                    <h1 style="text-align: center;">장비 반출입 대장</h1>
        <h2>${search.startDate} ~ ${search.endDate}</h2>
            ${printArea.outerHTML}
        </div>
         `;

        // 인쇄할 영역만 페이지에 표시
        document.body.innerHTML = printContent;

        // 인쇄 실행
        window.print();

        // 원래 페이지 내용 복원
        document.body.innerHTML = originalContent;

        // React의 경우 페이지를 복구하려면 전체를 다시 렌더링해야 하므로 필요하면 페이지를 강제 새로고침
        window.location.reload();
    }


    return (
        <Dialog>
            <DialogTrigger asChild>
                {isIconTrigger ? (
                    <button
                        type="button"
                        className="inline-flex items-center justify-center p-0 border-0 bg-transparent cursor-pointer hover:opacity-80 transition-opacity duration-200"
                        title="장비 반출입"
                        aria-label="장비 반출입"
                        onClick={handleOpenModalAndFetchData}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                             className="icon icon-tabler icons-tabler-outline icon-tabler-device-mobile-bolt"
                             aria-hidden="true"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M13.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"/>
                            <path d="M19 16l-2 3h4l-2 3"/>
                            <path d="M11 4h2"/>
                            <path d="M12 17v.01"/>
                        </svg>
                    </button>

                ) : (
                    <div
                        className="flex flex-row items-center justify-start gap-[8px] cursor-pointer transition-opacity duration-200 hover:opacity-80 text-white"
                        onClick={handleOpenModalAndFetchData}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 24 24"
                             fill="none"
                             stroke="currentColor"
                             strokeWidth="2"
                             strokeLinecap="round"
                             strokeLinejoin="round"
                             className="w-[22px] h-[22px] shrink-0"
                             aria-label="전산장비 반출입대장 아이콘">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M13.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"/>
                            <path d="M19 16l-2 3h4l-2 3"/>
                            <path d="M11 4h2"/>
                            <path d="M12 17v.01"/>
                        </svg>
                        <span className="text-white font-medium text-[12px]">
                            전산장비 반출입대장
                        </span>
                    </div>
                )}
            </DialogTrigger>
            {modalOpen &&
                <>
                <div className={`image-view-modal-background`} onClick={()=>{setModalOpen(false)}}/>
                <div
                    role="dialog" data-state="open" className=" h-[46rem] w-[80rem] max-w-[80rem] fixed top-[100px] left-1/2 -translate-x-1/2 z-50 grid gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg" tabindex="-1" style={{pointerEvents: "auto",fontSize: "12px", fontWeight: "normal" }} >
                <div className="flex text-center mt-5">
                    <ModalEquipmentWrite Listener={getList}/>
                    <DialogTitle className="text-center flex-grow mr-[150px] text-2xl" >장비 반출입 대장</DialogTitle>


                </div>

                    <div className="">

                        <SearchComponent Listener={getList} search={{search: search, fnc: setSearch}} col={2}
                                         setPageable={setPageable} dated={{date: date, fnc: setDate}}
                                         invisible={{size: true, fix: true}} placeholder={"장비명, 관리번호, 사용자, 용도"}>

                            <SearchComponentRadioGroup title={"구분"} value={search.ioCheck} type={ioCheck}
                                                       listener={(selected) => radioCheck(selected, "ioCheck")}/>
                            <SearchComponentRadioGroup title={"중요자료 삭제여부"} value={search.deleteCheck} type={deleteCheck}
                                                       listener={(selected) => radioCheck(selected, "deleteCheck")}/>
                            <SearchComponentRadioGroup title={"감염 여부"} value={search.infectionCheck}
                                                       type={infectionCheck}
                                                       listener={(selected) => radioCheck(selected, "infectionCheck")}/>
                        </SearchComponent>

                        <div className="w-[100%] h-[60px] pt-[16px] util-box align-middle">
                            {user && <abbr title={"엑셀 다운로드"}>
                                <button
                                    type="button"
                                    className="float-right mr-2"
                                    onClick={() => downloadExcelByEntity("Equipment", search)}
                                >
                                    <img src={ExcelIcon} className="w-[30px] h-[30px] mt-[3px] border"
                                         alt="excel-icon"/>
                                </button>
                            </abbr>}

                            <abbr title={"인쇄하기"}>
                                <button className="float-right mr-3" onClick={() => handlePrint("equipmentPrintArea")}>
                                    <img src={Printer} className={`w-[30px] h-[30px] mt-[5px] border`}/>
                                </button>
                            </abbr>

                        </div>


                        {data &&
                            <div id="equipmentPrintArea">
                            <TableEquipment header={EQUIPMENT_ACCESS_LIST_HEADER} data={data.content}
                                            paged={{pageable: pageable, setPageable: setPageable}} option={data.option}
                                            checked={{checked: checked, setChecked: setChecked}} size={10}
                                            notUse={{checkbox: true, number: true}}/>
                            </div>
                        }

                    </div>


                    <DialogFooter className="sm:justify-start">
                        <DialogClose asChild>
                            <Button type="button" variant="outline" onClick={() => setModalOpen(false)}>
                                닫기
                            </Button>
                        </DialogClose>
                    </DialogFooter>
                </div>
                </>
            }
        </Dialog>
    )
}
